import Image from "next/image";
import Panel from "./Panel";
import MetaRow from "./MetaRow";

/* ── 01 · A/B Testing Builder ── */
const ABTestMock = () => {
  const variants = [
    {
      id: 1,
      image: "/assets/testingOptimization/Background.svg",
      roas: "1.82×",
    },
    {
      id: 2,
      image: "/assets/testingOptimization/Background2.svg",
      roas: "3.41×",
    },
    {
      id: 3,
      image: "/assets/testingOptimization/Background3.svg",
      roas: "2.04×",
    },
    {
      id: 4,
      image: "/assets/testingOptimization/Background4.svg",
      roas: "1.41×",
    },
  ];
  return (
    <Panel>
      <MetaRow
        label={`Test #4 · “Hook Variations” · 4 live`}
        right="Day 3 / 7"
      />
      <hr className="border-white/10" />
      <div className="columns-2 gap-3">
        {variants.map((x) => (
          <div
            key={x.id}
            className="mb-2.5 break-inside-avoid overflow-hidden border border-[#FFFFFF14]/[8%]"
          >
            {/* Creative Preview */}
            <div className="bg-[linear-gradient(135deg,rgba(255,255,255,0.06),rgba(0,0,0,0.25))]">
              <Image
                src={x.image}
                alt={x.roas}
                width={800}
                height={1200}
                className="block h-auto w-full object-contain"
              />
            </div>

            {/* Meta */}
            <div className="flex flex-col gap-1 px-2.5 py-2">
              <div className="flex items-baseline justify-between">
                <span className="text-[8px] uppercase tracking-wide text-[#A59881]">
                  ROAS
                </span>

                <span className="tabular-nums text-xl font-medium text-white">
                  {x.roas}
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="flex items-center justify-between border border-[#3A65FF40]/[25%] bg-[#3257F90F]/[6%] px-3 py-3">
        <div className="flex flex-col gap-0.5">
          <span className="text-[8px] font-medium uppercase tracking-[0.14em] text-white ">
            Current Leader
          </span>
          <span className="text-[11px] font-medium text-white">
            Variant B · 87% lead vs. control
          </span>
        </div>
        <span className="shrink-0  px-2 py-1 text-[9px] font-medium uppercase tracking-wide text-white/70">
          94% Conf.
        </span>
      </div>
    </Panel>
  );
};

export default ABTestMock;
